import React from 'react';
import clsx from 'clsx';

import PropTypes from 'prop-types';
import ReactPopup from 'reactjs-popup';

import styles from './Popup.module.scss';
import './Popup.scss';

const Popup = React.forwardRef(({
  variant = 'default',
  children,
  trigger,
  containerSelector = null,
  position,
  className = '',
  closeOnContentClick = true,
  closeOnDocumentClick = true,
  closeOnEscape = true,
  onOpen = () => { },
  onClose = () => { },
  offsetY = 0,
  offsetX = 0,
  isOverflowEnabled = false,
}, ref) => {
  const onContentClick = (closeFn) => {
    if (closeOnContentClick) {
      closeFn();
    }
  };

  const renderContent = (close) => {
    if (typeof children === 'function') {
      return children(close);
    }

    if (React.isValidElement(children) && children.type !== React.Fragment) {
      return React.cloneElement(children, { closePopup: close });
    }

    return children;
  };

  return (
    <ReactPopup
      ref={ref}
      className={clsx(variant, className)}
      trigger={trigger}
      keepTooltipInside={containerSelector}
      position={position}
      on="click"
      closeOnDocumentClick={closeOnDocumentClick}
      closeOnEscape={closeOnEscape}
      onClose={onClose}
      onOpen={onOpen}
      offsetY={offsetY}
      offsetX={offsetX}
    >
      {(close) => (
        <div className={clsx(styles.popupContent, isOverflowEnabled ? 'overflow-visible' : 'overflow-hidden')} onClick={() => onContentClick(close)}>
          {renderContent(close)}
        </div>
      )}
    </ReactPopup>
  );
});
Popup.displayName = 'Popup';

Popup.propTypes = {
  variant: PropTypes.oneOf(['default', 'navbar', 'accounts', 'pdf', 'csv']),
  children: PropTypes.node.isRequired,
  trigger: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  className: PropTypes.string,
  closeOnContentClick: PropTypes.bool,
  closeOnDocumentClick: PropTypes.bool,
  closeOnEscape: PropTypes.bool,
  containerSelector: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  position: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  offsetY: PropTypes.number,
  offsetX: PropTypes.number,
};


export default Popup;
